module.exports = __webpack_public_path__ + "static/media/elevator-icon.986b280a.svg";